import { render, staticRenderFns } from "./TaskStatusChangedNotification.vue?vue&type=template&id=38b1e5f9"
import script from "./TaskStatusChangedNotification.vue?vue&type=script&lang=js"
export * from "./TaskStatusChangedNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports